// @ts-ignore - randomly triggers ts sometimes
const constants = import.meta.env || {};

export default constants;
